// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__rXN8E","additionalInfo":"AgreementModal_additionalInfo__g3qVz"};